// extracted by mini-css-extract-plugin
export default {"box":"TextAreaEditor_box__f12Kw","title":"TextAreaEditor_title__UYuxk"};